export interface InputProps {
  value: string | number;
  onChange: (value: string) => void;
  disabled?: boolean;
  valid?: boolean;
  placeholder?: string;
  type?: InputTypes;
  hasIcon?: boolean;
  id: string;
  name?: string;
  label?: string;
  errorMessage?: string;
  inverted?: boolean;
}

// https://www.w3schools.com/html/html_form_input_types.asp
export enum InputTypes {
  button = "button",
  checkbox = "checkbox",
  color = "color",
  date = "date",
  datetimeLocal = "datetime-local",
  email = "email",
  file = "file",
  hidden = "hidden",
  image = "image",
  month = "month",
  number = "number",
  password = "password",
  radio = "radio",
  range = "range",
  reset = "reset",
  search = "search",
  submit = "submit",
  tel = "tel",
  text = "text",
  time = "time",
  url = "url",
  week = "week",
}
